    // Product Data
    const productData = {
        title: 'SHEAVERA Face Serum (Vitamin C+HA)',
        variant: 'Face Serum (Vitamin C+HA)',
        price: '52.99',
        compareAtPrice: '57.99',
        variantId: '49772562940150',
        quantity: 1,
        image: 'https://cdn.shopify.com/s/files/1/0773/7756/9014/files/VITC_95c2bbe3-505f-4943-a643-c7394b67486c.jpg?v=1769447317'
    };

    let currentQuantity = 1;
    let countdownInterval;
    let totalSeconds = 14 * 24 * 60 * 60;

    function updateCountdownDisplay() {
        const days = Math.floor(totalSeconds / (24 * 60 * 60));
        const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
        const seconds = totalSeconds % 60;

        const daysElement = document.getElementById('countdownDays');
        const hoursElement = document.getElementById('countdownHours');
        const minutesElement = document.getElementById('countdownMinutes');
        const secondsElement = document.getElementById('countdownSeconds');

        if (daysElement) daysElement.textContent = String(days).padStart(2, '0');
        if (hoursElement) hoursElement.textContent = String(hours).padStart(2, '0');
        if (minutesElement) minutesElement.textContent = String(minutes).padStart(2, '0');
        if (secondsElement) secondsElement.textContent = String(seconds).padStart(2, '0');
    }

    function startCountdown() {
        if (countdownInterval) clearInterval(countdownInterval);
        updateCountdownDisplay();

        countdownInterval = setInterval(() => {
            if (totalSeconds <= 0) {
                totalSeconds = 14 * 24 * 60 * 60;
            } else {
                totalSeconds--;
            }
            updateCountdownDisplay();
        }, 1000);
    }

    function updateCartButtonText() {
        const addToCartBtn = document.getElementById('addToCart');
        if (!addToCartBtn) return;

        const labelSpan = addToCartBtn.querySelector('span');
        if (labelSpan) {
            labelSpan.textContent = `Add to Cart - $${parseFloat(productData.price).toFixed(2)}`;
        }
    }

    function handleAddToCartClick() {
        const addToCartBtn = document.getElementById('addToCart');
        if (!addToCartBtn) return;

        productData.quantity = parseInt(currentQuantity, 10) || 1;
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('added');
        addToCartBtn.innerHTML = `
            <svg viewBox="0 0 24 24">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <span>Adding...</span>
        `;

        const finalizeButton = (success) => {
            if (!addToCartBtn) return;
            addToCartBtn.disabled = false;

            if (success) {
                addToCartBtn.innerHTML = `
                    <svg viewBox="0 0 24 24">
                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                    <span>Added to Cart</span>
                `;

                setTimeout(() => {
                    addToCartBtn.classList.remove('added');
                    addToCartBtn.innerHTML = `
                        <svg viewBox="0 0 24 24">
                            <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
                        </svg>
                        <span>Add to Cart - $${parseFloat(productData.price).toFixed(2)}</span>
                    `;
                }, 2000);
            } else {
                addToCartBtn.classList.remove('added');
                updateCartButtonText();
            }
        };

        if (typeof window.addToCart === 'function') {
            try {
                Promise.resolve(window.addToCart(productData.variantId, productData.quantity))
                    .then(() => finalizeButton(true))
                    .catch((err) => {
                        console.error('Error adding to cart via global addToCart:', err);
                        finalizeButton(false);
                    });
            } catch (err) {
                console.error('Error adding to cart via global addToCart:', err);
                finalizeButton(false);
            }
            return;
        }

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: productData.variantId,
                quantity: productData.quantity,
                properties: {
                    '_Bundle offer': `Buy ${productData.quantity}`,
                    '_Bundle display total': `$${parseFloat(productData.price).toFixed(2)}`
                }
            })
        })
            .then((response) => {
                if (!response.ok) {
                    return response.json().then((error) => { throw error; });
                }
                return response.json();
            })
            .then(() => finalizeButton(true))
            .catch((err) => {
                console.error('Fallback cart add error:', err);
                finalizeButton(false);
            });
    }

    document.addEventListener('DOMContentLoaded', function() {
        startCountdown();

        /* ========= SWIPEABLE PRODUCT GALLERY ========= */
        const gallery = document.getElementById('mainImage');
        const track = document.getElementById('galleryTrack');
        const slides = track ? Array.from(track.querySelectorAll('.gallery-slide')) : [];
        const thumbnails = Array.from(document.querySelectorAll('.thumbnail'));
        let currentImageIndex = 0;
        let isDragging = false;
        let startX = 0;
        let currentX = 0;
        let dragDelta = 0;
        let activePointerId = null;

        function updateGallery(index, animate = true) {
            if (!track || !slides.length) return;

            const boundedIndex = Math.max(0, Math.min(index, slides.length - 1));
            currentImageIndex = boundedIndex;

            track.classList.toggle('is-dragging', !animate);
            track.style.transform = `translate3d(${-currentImageIndex * 100}%, 0, 0)`;

            thumbnails.forEach((thumbnail, thumbnailIndex) => {
                thumbnail.classList.toggle('active', thumbnailIndex === currentImageIndex);
            });

            const activeThumbnail = thumbnails[currentImageIndex];
            if (activeThumbnail) {
                productData.image = activeThumbnail.getAttribute('data-image') || productData.image;
            }
        }

        thumbnails.forEach((thumbnail) => {
            thumbnail.addEventListener('click', function() {
                const index = parseInt(this.getAttribute('data-index'), 10);
                if (!Number.isNaN(index)) updateGallery(index, true);
            });
        });

        if (gallery && track && slides.length) {
            gallery.addEventListener('pointerdown', function(event) {
                if (event.pointerType === 'mouse' && event.button !== 0) return;

                isDragging = true;
                activePointerId = event.pointerId;
                startX = event.clientX;
                currentX = startX;
                dragDelta = 0;
                gallery.classList.add('is-dragging');
                track.classList.add('is-dragging');

                if (gallery.setPointerCapture) gallery.setPointerCapture(event.pointerId);
            });

            gallery.addEventListener('pointermove', function(event) {
                if (!isDragging || event.pointerId !== activePointerId) return;

                currentX = event.clientX;
                dragDelta = currentX - startX;

                if ((currentImageIndex === 0 && dragDelta > 0) || (currentImageIndex === slides.length - 1 && dragDelta < 0)) {
                    dragDelta *= 0.32;
                }

                track.style.transform = `translate3d(calc(${-currentImageIndex * 100}% + ${dragDelta}px), 0, 0)`;
            });

            function finishSwipe(event) {
                if (!isDragging) return;
                if (event && activePointerId !== null && event.pointerId !== undefined && event.pointerId !== activePointerId) return;

                isDragging = false;
                gallery.classList.remove('is-dragging');
                track.classList.remove('is-dragging');

                const threshold = Math.min(90, gallery.clientWidth * 0.16);

                if (dragDelta <= -threshold && currentImageIndex < slides.length - 1) {
                    updateGallery(currentImageIndex + 1, true);
                } else if (dragDelta >= threshold && currentImageIndex > 0) {
                    updateGallery(currentImageIndex - 1, true);
                } else {
                    updateGallery(currentImageIndex, true);
                }

                dragDelta = 0;
                activePointerId = null;
            }

            gallery.addEventListener('pointerup', finishSwipe);
            gallery.addEventListener('pointercancel', finishSwipe);
            gallery.addEventListener('lostpointercapture', function() {
                if (isDragging) finishSwipe();
            });

            gallery.addEventListener('keydown', function(event) {
                if (event.key === 'ArrowLeft') {
                    event.preventDefault();
                    updateGallery(currentImageIndex - 1, true);
                }

                if (event.key === 'ArrowRight') {
                    event.preventDefault();
                    updateGallery(currentImageIndex + 1, true);
                }
            });

            updateGallery(0, false);
            requestAnimationFrame(() => track.classList.remove('is-dragging'));
        }

        /* ========= BUY 1 / 2 / 3 SELECTOR ========= */
        const buyButtons = document.querySelectorAll('.buy-button');
        buyButtons.forEach((button) => {
            button.addEventListener('click', function() {
                buyButtons.forEach((item) => item.classList.remove('selected'));
                this.classList.add('selected');

                currentQuantity = parseInt(this.dataset.quantity, 10) || 1;
                productData.price = this.dataset.price || '52.99';
                productData.quantity = currentQuantity;
                updateCartButtonText();
            });
        });

        const addToCartBtn = document.getElementById('addToCart');
        if (addToCartBtn) {
            addToCartBtn.addEventListener('click', handleAddToCartClick);
            updateCartButtonText();
        }

        const whatsappBtn = document.getElementById('whatsappButton');
        if (whatsappBtn) {
            whatsappBtn.addEventListener('click', function() {
                const message = `Hi! I'm interested in purchasing ${productData.title} from your website.\n\nProduct: ${productData.title}\nQuantity: ${currentQuantity}\nTotal: $${parseFloat(productData.price).toFixed(2)}\n\nCan you help me with the order?`;
                this.href = `https://wa.me/96181446674?text=${encodeURIComponent(message)}`;
            });
        }

        if (window.innerWidth > 768) {
            const productImages = document.querySelector('.product-images');
            const container = document.querySelector('.product-page-container');
            const headerHeight = 80;

            if (productImages && container) {
                window.addEventListener('scroll', function() {
                    const scrollPosition = window.pageYOffset;
                    const containerTop = container.offsetTop;
                    const containerHeight = container.offsetHeight;
                    const windowHeight = window.innerHeight;

                    if (scrollPosition > containerTop - headerHeight) {
                        productImages.style.top = `${headerHeight}px`;

                        const distanceFromBottom = containerTop + containerHeight - (scrollPosition + windowHeight);
                        if (distanceFromBottom < 100) {
                            productImages.style.top = `calc(${windowHeight - distanceFromBottom - 100}px)`;
                        }
                    } else {
                        productImages.style.top = `${containerTop - scrollPosition + headerHeight}px`;
                    }
                }, { passive: true });
            }
        }

        const reviewsLink = document.querySelector('a.rating-count');
        if (reviewsLink) {
            reviewsLink.addEventListener('click', function(event) {
                event.preventDefault();
                const reviewsSection = document.getElementById('reviews-section');

                if (reviewsSection) {
                    reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else {
                    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                }
            });
        }
    });
